<div class="row">
  @if(!hideTitle) {
    <div class="coil-details col text-secondary" style="padding-left: 0px;">
    <small>Coil details</small>
  </div>
  }
</div>
@if (coil && coil.coilSheetId) {
<div class="order-info mb-3 nowrap">
    <div class="order-id text-nowrap fs-5 fw-bold" style="padding-left: 0px;">Order {{ orderId }} <mat-icon style="padding-top: 5px;">keyboard_arrow_right</mat-icon> Coil {{coil.coilSheetId}}</div>
    @if(!hideOrderOverview) {
      <div>
      <div style="cursor: pointer;">
        <button class="order-overview btn btn-outline-primary btn-panel btn-sm text-nowrap d-flex align-items-center" style="width: auto;" (click)="this.viewOrderDetail.emit()">
          <i class="material-icons">list</i>&nbsp;&nbsp;Order overview
        </button>
      </div>
  </div>
}
</div>
<div class="row my-4">
  <div class="coil-info col-3 text-nowrap" style="padding-left: 0px;">Customer order # <br /> <span class="coil-data">{{coil.customerOrderNumber}}</span></div>
  <div class="coil-info col-3 text-nowrap" style="margin-right: 1rem; margin-left: 1rem;">Product type <br /><span class="coil-data">{{coil.productType}}</span></div>
  <div class="coil-info col-3 text-nowrap">Steel grade <br /><span class="coil-data">{{coil.gradeType}}</span></div>
  <div class="col-2">&nbsp;</div>
</div>
<div class="properties-container row mt-5">
  <div class="col">
    <table class="table p-3 my-3" style="width: 100%;" role="coildetailstableview" aria-describedby="coldetailstableview">
      <tr>
        <th></th>
      </tr>
      <tr>
        <td class="coil-properties">Order Width <span class="coil-properties-info text-nowrap">{{orderWidth}}</span></td>
        <td class="coil-properties">Order Thickness <span class="coil-properties-info text-nowrap">{{orderThickness}}</span></td>
        <td class="coil-properties">Weight <span class="coil-properties-info text-nowrap">{{coil.weight}} {{regionMeasurementUnits.weight}}</span></td>
      </tr>
      <tr class="my-3">
        <td class="coil-properties">Width range (incl. Tol.) <span class="coil-properties-info text-nowrap">{{ widthTolerance }}</span></td>
        <td class="coil-properties">Thickness range (incl. Tol.) <span class="coil-properties-info text-nowrap">{{ thicknessTolerance }}</span></td>
        <td class="coil-properties">Despatch date <span class="coil-properties-info text-nowrap">{{coil.dateOfDelivery | date: 'dd-MM-yyyy' }}</span></td>
      </tr>
      <tr>
        <td class="coil-properties">Outside diameter <span class="coil-properties-info text-nowrap">{{coil.outsideDiameter}} {{regionMeasurementUnits.width_thickness}}</span></td>
        <td class="coil-properties">Length <span class="coil-properties-info text-nowrap">{{coil.length}} {{regionMeasurementUnits.length}}</span></td>
        <td class="coil-properties">Order date <span class="coil-properties-info text-nowrap">{{ coil.orderDate | date: 'dd-MM-yyyy' }}</span></td>
      </tr>
      <tr>
        @if(coil.rm) {
          <td class="coil-properties">Rm <span class="coil-properties-info text-nowrap">{{Rm}}</span></td>
        }
        @if(coil.rp) {
          <td class="coil-properties">Rp <span class="coil-properties-info text-nowrap">{{Rp}}</span></td>
        }
        @if(coil.reH) {
          <td class="coil-properties">ReH <span class="coil-properties-info text-nowrap">{{ReH}}</span></td>
        }
        @if(coil.reL) {
          <td class="coil-properties">ReL <span class="coil-properties-info text-nowrap">{{ReL}}</span></td>
        }
      </tr>
    </table>
  </div>
</div>
} @else {
  <div class="d-flex justify-content-center align-items-center h-100">
    <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
  </div>
}
